import { getColorScheme } from '../../colors';
import { pxToRem } from '../../../../utils';
import { submenuIndicatorUrl } from './submenuIndicatorUrl';
export var toolbarMenuItemSubmenuIndicatorStyles = {
  root: function root(_ref) {
    var v = _ref.variables,
        rtl = _ref.rtl;
    var colors = getColorScheme(v.colorScheme);
    return Object.assign({
      backgroundImage: submenuIndicatorUrl(v.menuItemForeground || colors.foreground1),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }, rtl && {
      transform: "scaleX(-1)"
    }, {
      width: pxToRem(16),
      height: '100%',
      position: 'absolute',
      right: pxToRem(7),
      top: 0
    });
  }
};
//# sourceMappingURL=toolbarMenuItemSubmenuIndicatorStyles.js.map
